import { OktaAuth } from '@okta/okta-auth-js';
import { getOAuthIssuer, getOAuthClientId, getOAuthRedirectUri } from '@/common-utilities/env-utilities';

const issuer = getOAuthIssuer();
const clientId = getOAuthClientId();
const redirectUri = getOAuthRedirectUri() || `${window.location.origin}/login/callback`;

export const isOAuthConfigured = Boolean(issuer && clientId);

export const oktaAuth: OktaAuth | null = isOAuthConfigured
  ? new OktaAuth({
      issuer: issuer!,
      clientId: clientId!,
      redirectUri,
      scopes: ['openid', 'email', 'profile', 'offline_access'],
      pkce: true,
    })
  : null;

export default oktaAuth;
